<div class="main">
    <div class="container">
        <div class="brand-name">
            <a href="https://www.zisson.com/zisson-socialboards/"><strong>Socialboards</strong></a>
        </div>

        <h1>
            <span translate>Forbidden</span>
        </h1>
        <p class="info-text">
            <span translate> You don't have permission to access the requested page. </span>
            <br />
            <span translate>Either go</span>&nbsp;<a (click)="goToPreviousLink()" translate>back</a>&nbsp;<span
                translate
                >to the previous page, or</span
            >&nbsp;<a (click)="login()" translate>log in</a>&nbsp;<span translate>as different user.</span>
        </p>

        <div class="image-wrapper">
            <img src="/sb-tools/theme/images/errors/error-403.png" alt="403" />
        </div>
    </div>
</div>
